import { QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode, useEffect, useState } from "react";
import { createQueryClient } from "@/lib/queryClient";
import { StackToaster } from "@/shared/components/StackToaster";
import { usePageTheme } from "@/shared/hooks/usePageTheme";
import { MotionProvider } from "@/shared/motion/MotionProvider";

/** Mirrors the theme onto <html class="dark">, which the token stylesheet keys off. */
function ThemeSync() {
  const theme = usePageTheme();
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);
  return null;
}

/**
 * No `TooltipProvider`: this app shows no tooltips, and the provider alone brings Radix's tooltip,
 * popper and floating-ui onto the first load (NFR-SA-009). Mount it again with the first `Tooltip`.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <MotionProvider>
        <ThemeSync />
        {children}
        <StackToaster />
      </MotionProvider>
    </QueryClientProvider>
  );
}
